import React from 'react';

const IOSInstallGuide = ({ onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '92%',
      maxWidth: '420px',
      background: 'linear-gradient(135deg, #0d2035 0%, #071526 100%)',
      border: '1px solid rgba(197, 160, 89, 0.4)',
      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.85), 0 0 25px rgba(197, 160, 89, 0.25)',
      borderRadius: '16px',
      padding: '20px',
      zIndex: 1200,
      backdropFilter: 'blur(16px)',
      fontFamily: "'Inter', sans-serif",
      color: '#fff',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '1.4rem' }}>📱</span>
          <h4 style={{
            margin: 0,
            fontFamily: "'Orbitron', sans-serif",
            fontSize: '0.9rem',
            color: '#c5a059',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}>Instalar en iPhone / iPad</h4>
        </div>
        <button 
          onClick={onClose}
          style={{
            background: 'rgba(255, 255, 255, 0.08)',
            border: 'none',
            color: 'rgba(181, 200, 216, 0.8)',
            fontSize: '1rem',
            cursor: 'pointer',
            padding: '4px 8px',
            borderRadius: '50%',
            lineHeight: 1,
          }}
          aria-label="Cerrar guía"
        >
          ✕
        </button>
      </div>

      <p style={{
        margin: '0 0 14px',
        fontSize: '0.78rem',
        color: 'rgba(181, 200, 216, 0.9)',
        lineHeight: 1.45
      }}>
        Añade <strong style={{ color: '#c5a059' }}>Vortex EXANI-II</strong> a tu pantalla de inicio para una experiencia fluida de app nativa sin instalar desde la App Store:
      </p>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        fontSize: '0.78rem',
        background: 'rgba(0, 0, 0, 0.3)',
        padding: '12px 14px',
        borderRadius: '10px',
        border: '1px solid rgba(197, 160, 89, 0.15)'
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{
            background: '#c5a059',
            color: '#071526',
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.7rem',
            fontWeight: 'bold',
            flexShrink: 0,
            marginTop: '1px',
          }}>1</span>
          <span>Toca el icono de <strong>Compartir</strong> <span style={{ color: '#60a5fa', fontSize: '1rem', margin: '0 2px' }}>⎋</span> (el cuadrado con la flecha hacia arriba) en la barra de Safari.</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{
            background: '#c5a059',
            color: '#071526',
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.7rem',
            fontWeight: 'bold',
            flexShrink: 0,
            marginTop: '1px',
          }}>2</span>
          <span>Desliza hacia abajo en las opciones y pulsa <strong style={{ color: '#f59e0b' }}>&quot;Añadir a la pantalla de inicio&quot; ⊞</strong>.</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{
            background: '#c5a059',
            color: '#071526',
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.7rem',
            fontWeight: 'bold',
            flexShrink: 0,
            marginTop: '1px',
          }}>3</span>
          <span>Confirma pulsando <strong>&quot;Añadir&quot;</strong> en la esquina superior derecha.</span>
        </div>
      </div>

      <div style={{
        marginTop: '12px',
        padding: '8px 10px',
        background: 'rgba(197, 160, 89, 0.08)',
        borderRadius: '6px',
        border: '1px dashed rgba(197, 160, 89, 0.3)',
        fontSize: '0.7rem',
        color: 'rgba(197, 160, 89, 0.9)',
        lineHeight: 1.35
      }}>
        💡 <strong>Tip de iOS:</strong> Si usas Chrome o Google en tu iPhone, también puedes usar la opción de Compartir ⎋ o abrir este enlace directamente en Safari.
      </div>

      <button
        onClick={onClose}
        style={{
          width: '100%',
          marginTop: '14px',
          background: 'linear-gradient(135deg, #c5a059 0%, #a88440 100%)',
          border: 'none',
          borderRadius: '8px',
          color: '#071526',
          fontFamily: "'Orbitron', sans-serif",
          fontSize: '0.75rem',
          fontWeight: '800',
          padding: '11px 0',
          cursor: 'pointer',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '0 0 12px rgba(197, 160, 89, 0.4)',
        }}
      >
        ¡Entendido!
      </button>
    </div>
  );
};

export default IOSInstallGuide;

